import Layout from '@/layout';
var userRouter = {
  path: '/user',
  name: 'User',
  component: Layout,
  meta: {
    title: '用户管理'
  },
  children: [{
    path: 'list',
    name: 'UserList',
    component: function component() {
      return import('@/views/user/list/index');
    },
    meta: {
      title: '用户列表'
    }
  }, {
    path: 'label',
    name: 'UserLabel',
    component: function component() {
      return import('@/views/user/tag/index');
    },
    meta: {
      title: '用户标签'
    }
  }, {
    path: 'group',
    component: function component() {
      return import('@/views/user/group/index');
    },
    name: 'UserGroup',
    meta: {
      title: '用户分组'
    }
  }, {
    path: 'level',
    component: function component() {
      return import('@/views/user/level/index');
    },
    name: 'Grade',
    meta: {
      title: '用户等级'
    }
  }, {
    path: 'blacklist',
    name: 'UserBlackList',
    component: function component() {
      return import('@/views/user/blacklist/index');
    },
    meta: {
      title: '黑名单'
    }
  }, {
    path: 'search-list',
    component: function component() {
      return import('@/views/user/search/index');
    },
    name: 'UserSearchList',
    meta: {
      title: '搜索历史'
    }
  }, {
    path: 'betStatistics',
    component: function component() {
      return import('@/views/user/betStatistics/index');
    },
    name: 'BetStatistics',
    meta: {
      title: '日投注数据'
    }
  }, {
    path: 'rule',
    component: function component() {
      return import('@/views/user/rule/index');
    },
    name: 'Rule',
    meta: {
      title: '规则管理',
      icon: ''
    }
  }, {
    path: 'tactics',
    component: function component() {
      return import('@/views/user/tactics/index');
    },
    name: 'Tactics',
    meta: {
      title: '策略管理',
      icon: ''
    }
  }]
};
export default userRouter;